// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/app.eot?42391129", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/app.woff?42391129", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/app.ttf?42391129", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/app.svg?42391129", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#bpmnio" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * color scheme: https://color.adobe.com/create/color-wheel/?base=2&rule=Complementary&selected=4&name=My%20Color%20Theme&mode=rgb&rgbvalues=0.17030891601918655,0.4058823529411765,0.023676470588235302,0.5171907756812364,1,0.21666666666666667,0.3215686274509804,0.7058823529411765,0.08235294117647059,0.39483604076295736,0,0.4058823529411765,0.6889126559717383,0.08235294117647061,0.7058823529411765&swatchOrder=0,1,2,3,4
 */
* {
  box-sizing: border-box;
}
body,
html {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  color: #444;
  height: 100%;
  padding: 0;
  margin: 0;
}
h1,
h2,
h3,
h4 {
  font-weight: normal;
}
h2 {
  margin-top: 30px;
  margin-bottom: 10px;
}
ul {
  padding-left: 30px;
}
ol {
  padding-left: 30px;
}
/**
 * bpmn + custom icon definitions
 */
@font-face {
  font-family: 'app';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
}
[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-family: "app";
}
.icon-bpmn-io-logo:before {
  content: '\\e800';
}
/* '' */
.icon-loading:before {
  content: '\\f415';
}
/* '' */
.icon-picture:before {
  content: '\\f416';
}
/* '' */
.icon-plus:before {
  content: '\\f417';
}
/* '' */
.icon-plus-circled:before {
  content: '\\f418';
}
/* '' */
.icon-minus:before {
  content: '\\f419';
}
/* '' */
.icon-info:before {
  content: '\\f41a';
}
/* '' */
.icon-download:before {
  content: '\\f41b';
}
/* '' */
.icon-undo:before {
  content: '\\f41c';
}
/* '' */
.icon-redo:before {
  content: '\\f41d';
}
/* '' */
.icon-open:before {
  content: '\\f41e';
}
/* '' */
.icon-size-reset:before {
  content: '\\f41f';
}
/* '' */
.icon-comment:before {
  content: '\\f420';
}
/* '' */
.icon-keyboard:before {
  content: '\\f423';
}
/* '' */
.icon-resize-full:before {
  content: '\\f425';
}
/* '' */
.icon-resize-small:before {
  content: '\\f426';
}
/* '' */
/**
 * reset
 */
body {
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 14px;
}
a:link,
a:visited {
  color: #0e9663;
  font-weight: bold;
  text-decoration: none;
}
a:hover,
a:focus {
  color: #075035;
}
/**
 * project logo
 */
.project-logo {
  margin: 50px auto;
}
.project-logo a {
  display: inline-block;
  height: 4em;
  width: auto;
  color: #404040;
  margin: 0 auto;
}
.project-logo a svg {
  height: 100%;
}
.content,
.content > div {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.content > .screen {
  text-align: center;
  display: table;
  font-size: 16px;
}
.content > .screen .note {
  vertical-align: middle;
  text-align: center;
  display: table-cell;
}
.content .error .details {
  max-width: 500px;
  font-size: 12px;
  margin: 20px auto;
  text-align: left;
  color: #BD2828;
}
.content .error .error-log {
  border: solid 1px #BD2828;
  background: #fdf6f6;
  color: #BD2828;
}
.content .error .error-log:hover {
  background: #fefafa;
}
body:not(.error) .screen.error,
body:not(.intro) .screen.intro,
body:not(.loading) .screen.loading {
  display: none;
}
body.loading,
body.intro {
  opacity: 0;
  transition: opacity 1s;
}
body.loading.animate,
body.intro.animate {
  opacity: 1;
}
.screen.loading img {
  width: 48px;
}
.canvas {
  display: block;
}
body.shown .canvas,
body.loaded .canvas {
  display: block;
}
body.loaded .canvas svg {
  visibility: hidden;
}
body:not(.shown) .io-export,
body:not(.shown) .io-zoom-controls {
  display: none;
}
/** front page / drop zone */
.samples,
.message {
  max-width: 700px;
  margin: 15px auto;
}
@media (max-width: 720px) {
  .samples,
  .message {
    margin: 20px;
  }
  .samples {
    margin-bottom: 60px;
  }
}
.message {
  font-size: 20px;
}
.samples {
  margin-top: 80px;
  margin-bottom: 60px;
  opacity: 0.4;
  transition: ease-in 0.1s;
}
.samples:hover {
  opacity: 1;
}
.samples .sample {
  display: inline-block;
  max-width: 100%;
  vertical-align: top;
  position: relative;
}
.samples .caption {
  font-size: 13px;
  font-weight: normal;
  color: #666;
}
.samples .img {
  border: solid 5px #E9E9E9;
  border-radius: 5px;
  padding: 5px;
  width: 100%;
}
.samples .sample > a {
  display: block;
}
/** widgets **/
.io-control {
  background: #FAFAFA;
  border-radius: 2px;
  border: solid 1px #E0E0E0;
  padding: 5px;
}
.cjs-powered-by,
.bjs-powered-by {
  padding-bottom: 2px;
}
.close {
  color: #333 !important;
  font-size: 21px;
  font-weight: 700 !important;
  opacity: 0.6;
  line-height: 1;
  vertical-align: middle;
  margin-left: 5px;
}
.close:hover {
  opacity: 1;
}
.io-control .vr {
  height: 15px;
  display: inline-block;
  border-right: solid 1px #DDD;
}
.io-control hr {
  border: none;
  border-top: solid 1px #DDD;
  width: 15px;
}
.io-control-list .vr {
  margin-right: 0;
}
.io-control-list {
  list-style: none;
  padding: 5px;
  margin: 0;
}
.io-control-list a,
.io-control-list a:visited,
.io-control-list button {
  padding: 0;
  outline: none;
  cursor: pointer;
  font-size: 22px;
  line-height: 26px;
  color: #555555;
  background: none;
  border: none;
}
.io-control-list a:hover,
.io-control-list a:visited:hover,
.io-control-list button:hover {
  color: #333333;
}
.io-control-list a.inactive,
.io-control-list a:visited.inactive,
.io-control-list button.inactive {
  color: #E0E0E0;
  cursor: default;
}
.io-control-list.io-horizontal,
.io-control-list.io-horizontal li {
  display: inline-block;
}
.io-control-list.io-horizontal li + li {
  margin-left: 10px;
}
.io-control-list.io-horizontal a {
  padding: 2px;
}
.io-about {
  position: fixed;
  right: 10px;
}
.io-about li + li {
  margin-left: 15px;
}
body.shown .io-about {
  right: 90px;
}
.io-about a {
  font-size: 13px;
  line-height: 20px;
  font-weight: normal;
}
.io-about a:hover {
  background: #F0F0F0;
  border-radius: 2px;
}
.io-import-export {
  position: fixed;
  left: 10px;
}
.djs-palette {
  left: 10px !important;
  top: 10px !important;
}
.io-about {
  bottom: 8px;
}
.io-import-export {
  bottom: 10px;
}
.io-import {
  margin-right: 10px;
}
.io-zoom-controls {
  width: auto;
  position: fixed;
  right: 10px;
  bottom: 80px;
}
.io-editing-tools {
  width: auto;
  position: fixed;
  right: 5px;
  top: 5px;
  display: none;
}
.io-editing-tools .io-control {
  margin-left: 10px;
}
.io-editing-tools .io-control button {
  margin: 0;
}
.io-zoom-reset {
  margin-bottom: 10px;
}
.io-import-export .inactive {
  opacity: 0.3;
}
/**
 * import warnings dialog
 */
.import-warnings .error-log {
  width: 100%;
}
/**
 * utilities
 */
.hidden {
  display: none;
}
/**
 * alerts
 */
.io-alerts {
  position: fixed;
  top: 10px;
  width: 450px;
  text-align: center;
  left: 50%;
  margin-left: -450px / 2;
}
.io-alerts .alert {
  display: none;
  background: #eeefdf;
  padding: 10px 20px;
  line-height: 20px;
  margin: 0 auto 10px;
}
.io-alerts .alert.open {
  display: inline-flex;
}
.io-toggle-fullscreen {
  display: none;
}
.io-toggle-fullscreen.open {
  display: inline-block;
}
@media (max-width: 500px) {
  .io-alerts {
    width: 100%;
    text-align: center;
    left: 0;
    margin: 0;
  }
}
/**
 * dialogs
 */
.io-dialog {
  display: none;
}
.io-dialog.open {
  display: block;
}
.io-dialog.open:before {
  content: '';
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: #666;
  opacity: 0.2;
  z-index: 1001;
}
.io-dialog .content {
  position: fixed;
  width: 600px;
  left: 50%;
  transform: translateX(-50%);
  top: 100px;
  background: white;
  padding: 10px 30px 20px 30px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 2px;
  height: auto;
  z-index: 1001;
}
.keybindings-dialog .content {
  width: 450px;
  margin-left: -450px / 2;
}
.keybindings-dialog .binding {
  padding: 5px 10px;
  font-family: monospace;
}
textarea.error-log {
  border: solid 1px #CCC;
  background: #F6F6F6;
  padding: 10px;
  margin: 10px auto;
  width: 100%;
  min-height: 150px;
  display: block;
}
textarea.error-log:hover {
  background: #f9f9f9;
}
@media (max-width: 600px) {
  .io-dialog .content {
    left: 20px;
    right: 20px;
    top: 20px;
    width: auto;
    margin: 0;
  }
}
.spinner-border {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes spinner-keyframe {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.spinner-border:after {
  width: 22px;
  height: 22px;
  border: 4px solid #404040;
  content: " ";
  display: block;
  border-radius: 50%;
  border-color: #404040 #404040 #404040 transparent;
  animation: spinner-keyframe 0.7s linear infinite;
}
:full-screen .icon-resize:before {
  content: '\\e86e';
  /* see .icon-resize-small:before */
}
:-moz-full-screen .icon-resize:before {
  content: '\\e86e';
  /* see .icon-resize-small:before */
}
:-ms-full-screen .icon-resize:before {
  content: '\\e86e';
  /* see .icon-resize-small:before */
}
:-webkit-full-screen .icon-resize:before {
  content: '\\e86e';
  /* see .icon-resize-small:before */
}
.icon-resize:before {
  content: '\\e86d';
  /* see .icon-resize-full:before */
}
.icon-resize:before {
  content: '\\e86d';
  /* see .icon-resize-full:before */
}
.icon-resize:before {
  content: '\\e86d';
  /* see .icon-resize-full:before */
}
.icon-resize:before {
  content: '\\e86d';
  /* see .icon-resize-full:before */
}
.drop-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 50px;
  background: rgba(255, 255, 255, 0.9);
  z-index: 1000;
}
.drop-overlay .box {
  text-align: center;
  border: dashed 4px #CCC;
  height: 100%;
  width: 100%;
  display: table;
}
.drop-overlay .label {
  font-size: 26px;
  color: #888;
  margin: auto;
  display: table-cell;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./client/less/app.less","webpack://./client/less/_normalize.less","webpack://./client/less/_icons.less","webpack://./client/less/_icons_codes.less","webpack://./client/less/_style.less","webpack://./client/less/_fullscreen.less","webpack://./client/less/file-drop.css"],"names":[],"mappings":"AAAA;;EAEE;ACFF;EACE,sBAAA;ADIF;ACDA;;EACE,2DAAA;EAEA,eAAA;EACA,WAAA;EAEA,YAAA;EACA,UAAA;EACA,SAAA;ADEF;ACCA;;;;EACE,mBAAA;ADIF;ACDA;EACE,gBAAA;EACA,mBAAA;ADGF;ACAA;EACE,kBAAA;ADEF;ACCA;EACE,kBAAA;ADCF;AACA;;EAEE;AE7BF;EACE,kBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;AF4BF;AExBA;;EAEE,kBAAA;EACA,mBAAA;EACA,WAAA;EAEA,qBAAA;EACA,wBAAA;EACA,UAAA;EACA,kBAAA;EAEA,oBAAA;EACA,oBAAA;EAEA,gBAAA;AFuBF;AEpBA;;EAEE,kBAAA;AFsBF;AGzDA;EAA4B,gBAAA;AH4D5B;AACA,QAAQ;AG5DR;EAAuB,gBAAA;AH+DvB;AACA,QAAQ;AG/DR;EAAuB,gBAAA;AHkEvB;AACA,QAAQ;AGlER;EAAoB,gBAAA;AHqEpB;AACA,QAAQ;AGrER;EAA4B,gBAAA;AHwE5B;AACA,QAAQ;AGxER;EAAqB,gBAAA;AH2ErB;AACA,QAAQ;AG3ER;EAAoB,gBAAA;AH8EpB;AACA,QAAQ;AG9ER;EAAwB,gBAAA;AHiFxB;AACA,QAAQ;AGjFR;EAAoB,gBAAA;AHoFpB;AACA,QAAQ;AGpFR;EAAoB,gBAAA;AHuFpB;AACA,QAAQ;AGvFR;EAAoB,gBAAA;AH0FpB;AACA,QAAQ;AG1FR;EAA0B,gBAAA;AH6F1B;AACA,QAAQ;AG7FR;EAAuB,gBAAA;AHgGvB;AACA,QAAQ;AGhGR;EAAwB,gBAAA;AHmGxB;AACA,QAAQ;AGnGR;EAA2B,gBAAA;AHsG3B;AACA,QAAQ;AGtGR;EAA4B,gBAAA;AHyG5B;AACA,QAAQ;AACR;;EAEE;AIzHF;EACE,wCAAA;EACA,eAAA;AJ2HF;AIxHA;;EAEE,cAAA;EAEA,iBAAA;EACA,qBAAA;AJyHF;AItHA;;EAEE,cAAA;AJwHF;AACA;;EAEE;AIrHF;EACE,iBAAA;AJuHF;AIxHA;EAII,qBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AJuHJ;AI/HA;EAWM,YAAA;AJuHN;AIlHA;;EAEE,WAAA;EACA,YAAA;EAEA,gBAAA;AJmHF;AIhHA;EACE,kBAAA;EACA,cAAA;EAEA,eAAA;AJiHF;AI9GA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;AJgHF;AI7GA;EAGI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,cAAA;AJ4GJ;AIpHA;EAYI,yBAAA;EACA,mBAAA;EAEA,cAAA;AJ0GJ;AIxGI;EACE,mBAAA;AJ0GN;AIrGA;;;EAGE,aAAA;AJuGF;AIpGA;;EAEE,UAAA;EACA,sBAAA;AJsGF;AIpGE;;EACE,UAAA;AJuGJ;AInGA;EAEI,WAAA;AJoGJ;AIhGA;EACE,cAAA;AJkGF;AI/FA;;EAEE,cAAA;AJiGF;AI9FA;EACE,kBAAA;AJgGF;AI5FA;;EAEE,aAAA;AJ8FF;AACA,4BAA4B;AI1F5B;;EAEE,gBAAA;EACA,iBAAA;AJ4FF;AIzFA;EACE;;IAEE,YAAA;EJ2FF;EIxFA;IACE,mBAAA;EJ0FF;AACF;AIvFA;EACE,eAAA;AJyFF;AItFA;EACE,gBAAA;EACA,mBAAA;EAEA,YAAA;EACA,wBAAA;AJuFF;AIpFA;EACE,UAAA;AJsFF;AInFA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EAEA,kBAAA;AJoFF;AIjFA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AJmFF;AIhFA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AJkFF;AI/EA;EACE,cAAA;AJiFF;AACA,cAAc;AI7Ed;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AJ+EF;AI5EA;;EAEE,mBAAA;AJ8EF;AI3EA;EACE,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AJ6EF;AI1EA;EACE,UAAA;AJ4EF;AIzEA;EACE,YAAA;EACA,qBAAA;EACA,4BAAA;AJ2EF;AIxEA;EACE,YAAA;EACA,0BAAA;EACA,WAAA;AJ0EF;AIvEA;EACE,eAAA;AJyEF;AItEA;EACE,gBAAA;EAEA,YAAA;EACA,SAAA;AJuEF;AI3EA;;;EASI,UAAA;EACA,aAAA;EAEA,eAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;EAEA,gBAAA;EACA,YAAA;AJoEJ;AIlEI;;;EACE,cAAA;AJsEN;AInEI;;;EACE,cAAA;EACA,eAAA;AJuEN;AInEE;;EAEE,qBAAA;AJqEJ;AIlEE;EAGI,iBAAA;AJkEN;AIrEE;EAOI,YAAA;AJiEN;AI5DA;EACE,eAAA;EACA,WAAA;AJ8DF;AIhEA;EAKI,iBAAA;AJ8DJ;AIzDA;EACE,WAAA;AJ2DF;AIxDA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AJ0DF;AIvDA;EACE,mBAAA;EACA,kBAAA;AJyDF;AItDA;EACE,eAAA;EACA,UAAA;AJwDF;AIrDA;EACE,qBAAA;EACA,oBAAA;AJuDF;AIpDA;EACE,WAAA;AJsDF;AInDA;EACE,YAAA;AJqDF;AIlDA;EACE,kBAAA;AJoDF;AIjDA;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AJmDF;AIhDA;EACE,WAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EAEA,aAAA;AJiDF;AIvDA;EASI,iBAAA;AJiDJ;AI1DA;EAYM,SAAA;AJiDN;AI5CA;EACE,mBAAA;AJ8CF;AI3CA;EACE,YAAA;AJ6CF;AACA;;EAEE;AIzCF;EAEI,WAAA;AJ0CJ;AACA;;EAEE;AIrCF;EACE,aAAA;AJuCF;AACA;;EAEE;AIpCF;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;AJsCF;AI5CA;EASI,aAAA;EACA,mBAAA;EAEA,kBAAA;EAEA,iBAAA;EACA,mBAAA;AJoCJ;AIlCI;EACE,oBAAA;AJoCN;AI/BA;EACE,aAAA;AJiCF;AI/BE;EACE,qBAAA;AJiCJ;AI5BA;EACE;IACE,WAAA;IACA,kBAAA;IACA,OAAA;IACA,SAAA;EJ8BF;AACF;AACA;;EAEE;AI1BF;EACE,aAAA;AJ4BF;AI1BE;EACE,cAAA;AJ4BJ;AIzBE;EACE,WAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EAEA,gBAAA;EACA,YAAA;EAEA,aAAA;AJyBJ;AI3CA;EAsBI,eAAA;EAEA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EAEA,iBAAA;EACA,4BAAA;EAEA,wCAAA;EACA,kBAAA;EAEA,YAAA;EAEA,aAAA;AJmBJ;AIdA;EAGI,YAAA;EACA,uBAAA;AJcJ;AIlBA;EAQI,iBAAA;EACA,sBAAA;AJaJ;AITA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EAEA,iBAAA;EAEA,WAAA;EAEA,iBAAA;EAEA,cAAA;AJOF;AILE;EACE,mBAAA;AJOJ;AIHA;EACE;IACE,UAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;IAEA,SAAA;EJIF;AACF;AIAA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AJEF;AICA;EACE;IACE,uBAAA;EJCF;EICA;IACE,yBAAA;EJCF;AACF;AIEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iDAAA;EACA,gDAAA;AJAF;AKzhBA;EACE,gBAAA;EL2hBA,kCAAkC;AACpC;AKzhBA;EACE,gBAAA;EL2hBA,kCAAkC;AACpC;AKzhBA;EACE,gBAAA;EL2hBA,kCAAkC;AACpC;AKzhBA;EACE,gBAAA;EL2hBA,kCAAkC;AACpC;AKzhBA;EACE,gBAAA;EL2hBA,iCAAiC;AACnC;AKzhBA;EACE,gBAAA;EL2hBA,iCAAiC;AACnC;AKzhBA;EACE,gBAAA;EL2hBA,iCAAiC;AACnC;AKzhBA;EACE,gBAAA;EL2hBA,iCAAiC;AACnC;AMzjBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EAEA,aAAA;EAEA,oCAAA;EAEA,aAAA;ANwjBF;AMrjBA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;ANujBF;AMpjBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,sBAAA;ANqjBF","sourcesContent":["/**\n * color scheme: https://color.adobe.com/create/color-wheel/?base=2&rule=Complementary&selected=4&name=My%20Color%20Theme&mode=rgb&rgbvalues=0.17030891601918655,0.4058823529411765,0.023676470588235302,0.5171907756812364,1,0.21666666666666667,0.3215686274509804,0.7058823529411765,0.08235294117647059,0.39483604076295736,0,0.4058823529411765,0.6889126559717383,0.08235294117647061,0.7058823529411765&swatchOrder=0,1,2,3,4\n */\n* {\n  box-sizing: border-box;\n}\nbody,\nhtml {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 12px;\n  color: #444;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\nh1,\nh2,\nh3,\nh4 {\n  font-weight: normal;\n}\nh2 {\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\nul {\n  padding-left: 30px;\n}\nol {\n  padding-left: 30px;\n}\n/**\n * bpmn + custom icon definitions\n */\n@font-face {\n  font-family: 'app';\n  src: url('../font/app.eot?42391129');\n  src: url('../font/app.eot?42391129#iefix') format('embedded-opentype'), url('../font/app.woff?42391129') format('woff'), url('../font/app.ttf?42391129') format('truetype'), url('../font/app.svg?42391129#bpmnio') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  text-align: center;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1em;\n}\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-family: \"app\";\n}\n.icon-bpmn-io-logo:before {\n  content: '\\e800';\n}\n/* '' */\n.icon-loading:before {\n  content: '\\f415';\n}\n/* '' */\n.icon-picture:before {\n  content: '\\f416';\n}\n/* '' */\n.icon-plus:before {\n  content: '\\f417';\n}\n/* '' */\n.icon-plus-circled:before {\n  content: '\\f418';\n}\n/* '' */\n.icon-minus:before {\n  content: '\\f419';\n}\n/* '' */\n.icon-info:before {\n  content: '\\f41a';\n}\n/* '' */\n.icon-download:before {\n  content: '\\f41b';\n}\n/* '' */\n.icon-undo:before {\n  content: '\\f41c';\n}\n/* '' */\n.icon-redo:before {\n  content: '\\f41d';\n}\n/* '' */\n.icon-open:before {\n  content: '\\f41e';\n}\n/* '' */\n.icon-size-reset:before {\n  content: '\\f41f';\n}\n/* '' */\n.icon-comment:before {\n  content: '\\f420';\n}\n/* '' */\n.icon-keyboard:before {\n  content: '\\f423';\n}\n/* '' */\n.icon-resize-full:before {\n  content: '\\f425';\n}\n/* '' */\n.icon-resize-small:before {\n  content: '\\f426';\n}\n/* '' */\n/**\n * reset\n */\nbody {\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-size: 14px;\n}\na:link,\na:visited {\n  color: #0e9663;\n  font-weight: bold;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  color: #075035;\n}\n/**\n * project logo\n */\n.project-logo {\n  margin: 50px auto;\n}\n.project-logo a {\n  display: inline-block;\n  height: 4em;\n  width: auto;\n  color: #404040;\n  margin: 0 auto;\n}\n.project-logo a svg {\n  height: 100%;\n}\n.content,\n.content > div {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.content > .screen {\n  text-align: center;\n  display: table;\n  font-size: 16px;\n}\n.content > .screen .note {\n  vertical-align: middle;\n  text-align: center;\n  display: table-cell;\n}\n.content .error .details {\n  max-width: 500px;\n  font-size: 12px;\n  margin: 20px auto;\n  text-align: left;\n  color: #BD2828;\n}\n.content .error .error-log {\n  border: solid 1px #BD2828;\n  background: #fdf6f6;\n  color: #BD2828;\n}\n.content .error .error-log:hover {\n  background: #fefafa;\n}\nbody:not(.error) .screen.error,\nbody:not(.intro) .screen.intro,\nbody:not(.loading) .screen.loading {\n  display: none;\n}\nbody.loading,\nbody.intro {\n  opacity: 0;\n  transition: opacity 1s;\n}\nbody.loading.animate,\nbody.intro.animate {\n  opacity: 1;\n}\n.screen.loading img {\n  width: 48px;\n}\n.canvas {\n  display: block;\n}\nbody.shown .canvas,\nbody.loaded .canvas {\n  display: block;\n}\nbody.loaded .canvas svg {\n  visibility: hidden;\n}\nbody:not(.shown) .io-export,\nbody:not(.shown) .io-zoom-controls {\n  display: none;\n}\n/** front page / drop zone */\n.samples,\n.message {\n  max-width: 700px;\n  margin: 15px auto;\n}\n@media (max-width: 720px) {\n  .samples,\n  .message {\n    margin: 20px;\n  }\n  .samples {\n    margin-bottom: 60px;\n  }\n}\n.message {\n  font-size: 20px;\n}\n.samples {\n  margin-top: 80px;\n  margin-bottom: 60px;\n  opacity: 0.4;\n  transition: ease-in 0.1s;\n}\n.samples:hover {\n  opacity: 1;\n}\n.samples .sample {\n  display: inline-block;\n  max-width: 100%;\n  vertical-align: top;\n  position: relative;\n}\n.samples .caption {\n  font-size: 13px;\n  font-weight: normal;\n  color: #666;\n}\n.samples .img {\n  border: solid 5px #E9E9E9;\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n}\n.samples .sample > a {\n  display: block;\n}\n/** widgets **/\n.io-control {\n  background: #FAFAFA;\n  border-radius: 2px;\n  border: solid 1px #E0E0E0;\n  padding: 5px;\n}\n.cjs-powered-by,\n.bjs-powered-by {\n  padding-bottom: 2px;\n}\n.close {\n  color: #333 !important;\n  font-size: 21px;\n  font-weight: 700 !important;\n  opacity: 0.6;\n  line-height: 1;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n.close:hover {\n  opacity: 1;\n}\n.io-control .vr {\n  height: 15px;\n  display: inline-block;\n  border-right: solid 1px #DDD;\n}\n.io-control hr {\n  border: none;\n  border-top: solid 1px #DDD;\n  width: 15px;\n}\n.io-control-list .vr {\n  margin-right: 0;\n}\n.io-control-list {\n  list-style: none;\n  padding: 5px;\n  margin: 0;\n}\n.io-control-list a,\n.io-control-list a:visited,\n.io-control-list button {\n  padding: 0;\n  outline: none;\n  cursor: pointer;\n  font-size: 22px;\n  line-height: 26px;\n  color: #555555;\n  background: none;\n  border: none;\n}\n.io-control-list a:hover,\n.io-control-list a:visited:hover,\n.io-control-list button:hover {\n  color: #333333;\n}\n.io-control-list a.inactive,\n.io-control-list a:visited.inactive,\n.io-control-list button.inactive {\n  color: #E0E0E0;\n  cursor: default;\n}\n.io-control-list.io-horizontal,\n.io-control-list.io-horizontal li {\n  display: inline-block;\n}\n.io-control-list.io-horizontal li + li {\n  margin-left: 10px;\n}\n.io-control-list.io-horizontal a {\n  padding: 2px;\n}\n.io-about {\n  position: fixed;\n  right: 10px;\n}\n.io-about li + li {\n  margin-left: 15px;\n}\nbody.shown .io-about {\n  right: 90px;\n}\n.io-about a {\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: normal;\n}\n.io-about a:hover {\n  background: #F0F0F0;\n  border-radius: 2px;\n}\n.io-import-export {\n  position: fixed;\n  left: 10px;\n}\n.djs-palette {\n  left: 10px !important;\n  top: 10px !important;\n}\n.io-about {\n  bottom: 8px;\n}\n.io-import-export {\n  bottom: 10px;\n}\n.io-import {\n  margin-right: 10px;\n}\n.io-zoom-controls {\n  width: auto;\n  position: fixed;\n  right: 10px;\n  bottom: 80px;\n}\n.io-editing-tools {\n  width: auto;\n  position: fixed;\n  right: 5px;\n  top: 5px;\n  display: none;\n}\n.io-editing-tools .io-control {\n  margin-left: 10px;\n}\n.io-editing-tools .io-control button {\n  margin: 0;\n}\n.io-zoom-reset {\n  margin-bottom: 10px;\n}\n.io-import-export .inactive {\n  opacity: 0.3;\n}\n/**\n * import warnings dialog\n */\n.import-warnings .error-log {\n  width: 100%;\n}\n/**\n * utilities\n */\n.hidden {\n  display: none;\n}\n/**\n * alerts\n */\n.io-alerts {\n  position: fixed;\n  top: 10px;\n  width: 450px;\n  text-align: center;\n  left: 50%;\n  margin-left: -450px / 2;\n}\n.io-alerts .alert {\n  display: none;\n  background: #eeefdf;\n  padding: 10px 20px;\n  line-height: 20px;\n  margin: 0 auto 10px;\n}\n.io-alerts .alert.open {\n  display: inline-flex;\n}\n.io-toggle-fullscreen {\n  display: none;\n}\n.io-toggle-fullscreen.open {\n  display: inline-block;\n}\n@media (max-width: 500px) {\n  .io-alerts {\n    width: 100%;\n    text-align: center;\n    left: 0;\n    margin: 0;\n  }\n}\n/**\n * dialogs\n */\n.io-dialog {\n  display: none;\n}\n.io-dialog.open {\n  display: block;\n}\n.io-dialog.open:before {\n  content: '';\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  background: #666;\n  opacity: 0.2;\n  z-index: 1001;\n}\n.io-dialog .content {\n  position: fixed;\n  width: 600px;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 100px;\n  background: white;\n  padding: 10px 30px 20px 30px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 2px;\n  height: auto;\n  z-index: 1001;\n}\n.keybindings-dialog .content {\n  width: 450px;\n  margin-left: -450px / 2;\n}\n.keybindings-dialog .binding {\n  padding: 5px 10px;\n  font-family: monospace;\n}\ntextarea.error-log {\n  border: solid 1px #CCC;\n  background: #F6F6F6;\n  padding: 10px;\n  margin: 10px auto;\n  width: 100%;\n  min-height: 150px;\n  display: block;\n}\ntextarea.error-log:hover {\n  background: #f9f9f9;\n}\n@media (max-width: 600px) {\n  .io-dialog .content {\n    left: 20px;\n    right: 20px;\n    top: 20px;\n    width: auto;\n    margin: 0;\n  }\n}\n.spinner-border {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: white;\n  z-index: 200;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@keyframes spinner-keyframe {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.spinner-border:after {\n  width: 22px;\n  height: 22px;\n  border: 4px solid #404040;\n  content: \" \";\n  display: block;\n  border-radius: 50%;\n  border-color: #404040 #404040 #404040 transparent;\n  animation: spinner-keyframe 0.7s linear infinite;\n}\n:full-screen .icon-resize:before {\n  content: '\\e86e';\n  /* see .icon-resize-small:before */\n}\n:-moz-full-screen .icon-resize:before {\n  content: '\\e86e';\n  /* see .icon-resize-small:before */\n}\n:-ms-full-screen .icon-resize:before {\n  content: '\\e86e';\n  /* see .icon-resize-small:before */\n}\n:-webkit-full-screen .icon-resize:before {\n  content: '\\e86e';\n  /* see .icon-resize-small:before */\n}\n.icon-resize:before {\n  content: '\\e86d';\n  /* see .icon-resize-full:before */\n}\n.icon-resize:before {\n  content: '\\e86d';\n  /* see .icon-resize-full:before */\n}\n.icon-resize:before {\n  content: '\\e86d';\n  /* see .icon-resize-full:before */\n}\n.icon-resize:before {\n  content: '\\e86d';\n  /* see .icon-resize-full:before */\n}\n.drop-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 50px;\n  background: rgba(255, 255, 255, 0.9);\n  z-index: 1000;\n}\n.drop-overlay .box {\n  text-align: center;\n  border: dashed 4px #CCC;\n  height: 100%;\n  width: 100%;\n  display: table;\n}\n.drop-overlay .label {\n  font-size: 26px;\n  color: #888;\n  margin: auto;\n  display: table-cell;\n  vertical-align: middle;\n}\n","* {\n  box-sizing: border-box;\n}\n\nbody, html {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\n  font-size: 12px;\n  color: #444;\n\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n\nh1, h2, h3, h4 {\n  font-weight: normal;\n}\n\nh2 {\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\nul {\n  padding-left: 30px;\n}\n\nol {\n  padding-left: 30px;\n}","/**\n * bpmn + custom icon definitions\n */\n\n@font-face {\n  font-family: 'app';\n  src: url('../font/app.eot?42391129');\n  src: url('../font/app.eot?42391129#iefix') format('embedded-opentype'),\n       url('../font/app.woff?42391129') format('woff'),\n       url('../font/app.ttf?42391129') format('truetype'),\n       url('../font/app.svg?42391129#bpmnio') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  text-align: center;\n\n  font-variant: normal;\n  text-transform: none;\n\n  line-height: 1em;\n}\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-family: \"app\";\n}\n\n@import \"_icons_codes\";",".icon-bpmn-io-logo:before { content: '\\e800'; } /* '' */\n.icon-loading:before { content: '\\f415'; } /* '' */\n.icon-picture:before { content: '\\f416'; } /* '' */\n.icon-plus:before { content: '\\f417'; } /* '' */\n.icon-plus-circled:before { content: '\\f418'; } /* '' */\n.icon-minus:before { content: '\\f419'; } /* '' */\n.icon-info:before { content: '\\f41a'; } /* '' */\n.icon-download:before { content: '\\f41b'; } /* '' */\n.icon-undo:before { content: '\\f41c'; } /* '' */\n.icon-redo:before { content: '\\f41d'; } /* '' */\n.icon-open:before { content: '\\f41e'; } /* '' */\n.icon-size-reset:before { content: '\\f41f'; } /* '' */\n.icon-comment:before { content: '\\f420'; } /* '' */\n.icon-keyboard:before { content: '\\f423'; } /* '' */\n.icon-resize-full:before { content: '\\f425'; } /* '' */\n.icon-resize-small:before { content: '\\f426'; } /* '' */","/**\n * reset\n */\nbody {\n  font-family: \"IBM Plex Sans\",sans-serif;\n  font-size: 14px;\n}\n\na:link,\na:visited {\n  color: @link-color;\n\n  font-weight: bold;\n  text-decoration: none;\n}\n\na:hover,\na:focus {\n  color: @link-color-hover;\n}\n\n/**\n * project logo\n */\n.project-logo {\n  margin: 50px auto;\n\n  a {\n    display: inline-block;\n    height: 4em;\n    width: auto;\n    color: #404040;\n    margin: 0 auto;\n\n    svg {\n      height: 100%;\n    }\n  }\n}\n\n.content,\n.content > div {\n  width: 100%;\n  height: 100%;\n\n  overflow: hidden;\n}\n\n.content > .screen {\n  text-align: center;\n  display: table;\n\n  font-size: 16px;\n}\n\n.content > .screen .note {\n  vertical-align: middle;\n  text-align: center;\n  display: table-cell;\n}\n\n.content .error {\n\n  .details {\n    max-width: 500px;\n    font-size: 12px;\n    margin: 20px auto;\n    text-align: left;\n\n    color: #BD2828;\n  }\n\n  .error-log {\n    border: solid 1px #BD2828;\n    background: lighten(#BD2828, 53%);\n\n    color: #BD2828;\n\n    &:hover {\n      background: lighten(lighten(#BD2828, 53%), 1%);\n    }\n  }\n}\n\nbody:not(.error) .screen.error,\nbody:not(.intro) .screen.intro,\nbody:not(.loading) .screen.loading {\n  display: none;\n}\n\nbody.loading,\nbody.intro {\n  opacity: 0;\n  transition: opacity 1s;\n\n  &.animate {\n    opacity: 1;\n  }\n}\n\n.screen.loading {\n  img {\n    width: 48px;\n  }\n}\n\n.canvas {\n  display: block;\n}\n\nbody.shown .canvas,\nbody.loaded .canvas {\n  display: block;\n}\n\nbody.loaded .canvas svg {\n  visibility: hidden;\n}\n\n\nbody:not(.shown) .io-export,\nbody:not(.shown) .io-zoom-controls {\n  display: none;\n}\n\n/** front page / drop zone */\n\n.samples,\n.message {\n  max-width: 700px;\n  margin: 15px auto;\n}\n\n@media (max-width: 720px) {\n  .samples,\n  .message {\n    margin: 20px;\n  }\n\n  .samples {\n    margin-bottom: 60px;\n  }\n}\n\n.message {\n  font-size: 20px;\n}\n\n.samples {\n  margin-top: 80px;\n  margin-bottom: 60px;\n\n  opacity: 0.4;\n  transition: ease-in 0.1s;\n}\n\n.samples:hover {\n  opacity: 1;\n}\n\n.samples .sample {\n  display: inline-block;\n  max-width: 100%;\n  vertical-align: top;\n\n  position: relative;\n}\n\n.samples .caption {\n  font-size: 13px;\n  font-weight: normal;\n  color: #666;\n}\n\n.samples .img {\n  border: solid 5px #E9E9E9;\n  border-radius: 5px;\n  padding: 5px;\n  width: 100%;\n}\n\n.samples .sample > a {\n  display: block;\n}\n\n/** widgets **/\n\n.io-control {\n  background: #FAFAFA;\n  border-radius: 2px;\n  border: solid 1px #E0E0E0;\n  padding: 5px;\n}\n\n.cjs-powered-by,\n.bjs-powered-by {\n  padding-bottom: 2px;\n}\n\n.close {\n  color: #333 !important;\n  font-size: 21px;\n  font-weight: 700 !important;\n  opacity: .6;\n  line-height: 1;\n  vertical-align: middle;\n  margin-left: 5px;\n}\n\n.close:hover {\n  opacity: 1;\n}\n\n.io-control .vr {\n  height: 15px;\n  display: inline-block;\n  border-right: solid 1px #DDD;\n}\n\n.io-control hr {\n  border: none;\n  border-top: solid 1px #DDD;\n  width: 15px;\n}\n\n.io-control-list .vr {\n  margin-right: 0;\n}\n\n.io-control-list {\n  list-style: none;\n\n  padding: 5px;\n  margin: 0;\n\n  a,\n  a:visited,\n  button {\n    padding: 0;\n    outline: none;\n\n    cursor: pointer;\n    font-size: 22px;\n    line-height: 26px;\n\n    color: @button-color;\n\n    background: none;\n    border: none;\n\n    &:hover {\n      color: @button-color-hover;\n    }\n\n    &.inactive {\n      color: @button-color-inactive;\n      cursor: default;\n    }\n  }\n\n  &.io-horizontal,\n  &.io-horizontal li {\n    display: inline-block;\n  }\n\n  &.io-horizontal {\n\n    li + li {\n      margin-left: 10px;\n    }\n\n    a {\n      padding: 2px;\n    }\n  }\n}\n\n.io-about {\n  position: fixed;\n  right: 10px;\n\n  li + li {\n    margin-left: 15px;\n  }\n\n}\n\nbody.shown .io-about {\n  right: 90px;\n}\n\n.io-about a {\n  font-size: 13px;\n  line-height: 20px;\n  font-weight: normal;\n}\n\n.io-about a:hover {\n  background: #F0F0F0;\n  border-radius: 2px;\n}\n\n.io-import-export {\n  position: fixed;\n  left: 10px;\n}\n\n.djs-palette {\n  left: 10px !important;\n  top: 10px !important;\n}\n\n.io-about {\n  bottom: 8px;\n}\n\n.io-import-export {\n  bottom: 10px;\n}\n\n.io-import {\n  margin-right: 10px;\n}\n\n.io-zoom-controls {\n  width: auto;\n  position: fixed;\n  right: 10px;\n  bottom: 80px;\n}\n\n.io-editing-tools {\n  width: auto;\n  position: fixed;\n  right: 5px;\n  top: 5px;\n\n  display: none;\n\n  .io-control {\n    margin-left: 10px;\n\n    button {\n      margin: 0;\n    }\n  }\n}\n\n.io-zoom-reset {\n  margin-bottom: 10px;\n}\n\n.io-import-export .inactive {\n  opacity: 0.3;\n}\n\n\n/**\n * import warnings dialog\n */\n.import-warnings {\n  .error-log {\n    width: 100%;\n  }\n}\n\n/**\n * utilities\n */\n\n.hidden {\n  display: none;\n}\n\n/**\n * alerts\n */\n.io-alerts {\n  position: fixed;\n  top: 10px;\n  width: @alert-width;\n  text-align: center;\n  left: 50%;\n  margin-left: -@alert-width / 2;\n\n  .alert {\n    display: none;\n    background: #eeefdf;\n\n    padding: 10px 20px;\n\n    line-height: 20px;\n    margin: 0 auto 10px;\n\n    &.open {\n      display: inline-flex;\n    }\n  }\n}\n\n.io-toggle-fullscreen {\n  display: none;\n\n  &.open {\n    display: inline-block;\n  }\n}\n\n\n@media (max-width: (@alert-width + 50 )) {\n  .io-alerts {\n    width: 100%;\n    text-align: center;\n    left: 0;\n    margin: 0;\n  }\n}\n\n\n/**\n * dialogs\n */\n.io-dialog {\n  display: none;\n\n  &.open {\n    display: block;\n  }\n\n  &.open:before {\n    content: '';\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n\n    background: #666;\n    opacity: 0.2;\n\n    z-index: 1001;\n  }\n\n  .content {\n    position: fixed;\n\n    width: @dialog-width;\n    left: 50%;\n    transform: translateX(-50%);\n    top: 100px;\n\n    background: white;\n    padding: 10px 30px 20px 30px;\n\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n    border-radius: 2px;\n\n    height: auto;\n\n    z-index: 1001;\n  }\n\n}\n\n.keybindings-dialog {\n\n  .content {\n    width: @alert-width;\n    margin-left: -@alert-width / 2;\n  }\n\n  .binding {\n    padding: 5px 10px;\n    font-family: monospace;\n  }\n}\n\ntextarea.error-log {\n  border: solid 1px #CCC;\n  background: #F6F6F6;\n  padding: 10px;\n\n  margin: 10px auto;\n\n  width: 100%;\n\n  min-height: 150px;\n\n  display: block;\n\n  &:hover {\n    background: lighten(#F6F6F6, 1%);\n  }\n}\n\n@media (max-width: @dialog-width) {\n  .io-dialog .content {\n    left: 20px;\n    right: 20px;\n    top: 20px;\n    width: auto;\n\n    margin: 0;\n  }\n}\n\n\n.spinner-border {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: white;\n  z-index: 200;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@keyframes spinner-keyframe {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-border:after {\n  width: 22px;\n  height: 22px;\n  border: 4px solid @loader-color;\n  content: \" \";\n  display: block;\n  border-radius: 50%;\n  border-color: @loader-color @loader-color @loader-color transparent;\n  animation: spinner-keyframe 0.7s linear infinite;\n}",":full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n:-moz-full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n:-ms-full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n:-webkit-full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n",".drop-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n\n  padding: 50px;\n\n  background: rgba(255, 255, 255, .9);\n\n  z-index: 1000;\n}\n\n.drop-overlay .box {\n  text-align: center;\n  border: dashed 4px #CCC;\n  height: 100%;\n  width: 100%;\n  display: table;\n}\n\n.drop-overlay .label {\n  font-size: 26px;\n  color: #888;\n  margin: auto;\n\n  display: table-cell;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
